import { LanguageCode } from '@cms-max/medicare-api-sdk'
import { CoreDerivedEventData } from 'pubsub/core'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getUserLoggedInState } from 'redux/reducers/users'

export const useDerivedCoreEventData = () => {
  const authenticated = useSelector(getUserLoggedInState)
  const { i18n } = useTranslation()

  const derivedData = useMemo((): CoreDerivedEventData => {
    return {
      authenticated,
      // LanguageCode is an enum but stores as a string ,so we can cast the tytpe without issue here
      language: i18n.language as LanguageCode,
      title: document.title,
      url: window.location.href
    }
  }, [authenticated, i18n.language])

  return derivedData
}
